import { twMerge } from "tailwind-merge";
import { forwardRef } from "react";
import { TableFooterBase, type TableFooterBaseProps } from "@core/ui";

export type Props = Omit<TableFooterBaseProps, "data-testid">;

/**
 * Styled table footer section wrapping TableFooterBase.
 */
export const TableFooter = forwardRef<HTMLTableSectionElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <TableFooterBase
        ref={ref}
        className={twMerge("border-t border-brand-800", className)}
        data-testid="table-footer"
        {...props}
      />
    );
  }
);

TableFooter.displayName = "TableFooter";

export default TableFooter;

